export const TRACER_STATUS_MESSAGE = {
    TERMINATE_TRACE_MESSAGE: 'TERMINATE_TRACE_MESSAGE',
    API_ERROR: 'API_ERROR',
};
